import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=d5fb4c78&scoped=true&"
import script from "./login-form.vue?vue&type=script&lang=js&"
export * from "./login-form.vue?vue&type=script&lang=js&"
import style0 from "./login-form.vue?vue&type=style&index=0&id=d5fb4c78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fb4c78",
  null
  
)

export default component.exports